import { render, staticRenderFns } from "./DashboardNew.vue?vue&type=template&id=6f57b562&scoped=true&"
import script from "./DashboardNew.vue?vue&type=script&lang=js&"
export * from "./DashboardNew.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNew.vue?vue&type=style&index=0&id=6f57b562&prod&scoped=true&lang=css&"
import style1 from "./DashboardNew.vue?vue&type=style&index=1&id=6f57b562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f57b562",
  null
  
)

export default component.exports